module.exports = __webpack_public_path__ + "img/id-card-solid.f4bec228.svg";